import { Typography, styled } from '@mui/material';

export const OrdersShowResponseTitleStyled = styled(Typography)({
  position: 'absolute',
  top: '-13px',
  left: '8px',
  background: 'linear-gradient(to bottom, transparent 0%,transparent 50%, white 50%, white 100%)',
  color: 'rgba(0,0,0,0.38)',
  padding: '3px 5px',
  zIndex: 1,
});
